<script setup lang="ts">
const { isError = false } = defineProps<{ isError?: boolean }>();
</script>

<template>
    <div class="field" :class="{ field_error: isError }">
        <div v-if="$slots.title" class="field__title">
            <slot name="title" />
        </div>
        <div v-if="$slots.hintTop" class="field__hint field__hint_top">
            <slot name="hintTop" />
        </div>
        <div class="field__body">
            <slot />
        </div>
        <div v-if="$slots.hintBottom" class="field__hint field__hint_bottom">
            <slot name="hintBottom" />
        </div>
    </div>
</template>

<style scoped>
.field {
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
}

.field__title {
    margin-bottom: 12px;
    font-size: calc(var(--custom-font-size) * 1.143);
    font-weight: 700;
    line-height: 1.25;
    user-select: none;
}

.field__body {
    margin-top: 6px;
    margin-bottom: 6px;
}

.field__hint {
    font-size: calc(var(--custom-font-size) * 0.857);
    line-height: 1.333;
    user-select: none;
}

.field__hint_top {
    color: var(--custom-color-gray);
    filter: grayscale(0.55);
    font-size: var(--custom-font-size);
    line-height: 1;
}

.field_error .field__hint {
    color: var(--color-error);
}
</style>
